// SET INITIAL VARIABLES
let timer = null;

const getSmoothScrollTarget = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('smoothScroll')) {
    return urlParams.get('smoothScroll');
  }
  return false;
};

const checkForScrollTarget = () => {
  let smoothScrollTarget = '';

  if (getSmoothScrollTarget()) {
    smoothScrollTarget = getSmoothScrollTarget();

    $('[data-cms-module-banner][data-fullscreen-scroll-item]').each(function (index) {
      if (this.id === smoothScrollTarget) {
        setTimeout(() => {
          window.fullpage_api.moveTo(index + 1);
        }, 500);
      }
    });
  }
};

// CUSTOM TIMER LOGIK FOR ENABLE SCROLLING
const timerLogik = (timeoutValue) => {
  if (timer !== null) {
    window.clearTimeout(timer);
  }

  timer = setTimeout(() => {
    window.fullpage_api.setAllowScrolling(true);
  }, timeoutValue);
};

// ENABLE SCROLLING LOGIK
const enableScrollingLogik = (target) => {
  target.on('scroll', (e) => {
    timerLogik(100);
  });

  target.on('touchend', (e) => {
    window.fullpage_api.setAllowScrolling(true);
  });

  target.on('wheel', (e) => {
    timerLogik(250);
  });
};

// SUDO CHECK IF IT'S AN IPAD PRO
const iPadCheck = () => {
  return (
    (/\b(iPad)\b/.test(window.navigator.userAgent) && /WebKit/.test(window.navigator.userAgent) && !window.MSStream) ||
    (window.navigator.platform === 'MacIntel' &&
      window.navigator.maxTouchPoints &&
      window.navigator.maxTouchPoints === 5)
  );
};

const initFullScreenScroll = () => {
  if ($('#page--inside-simplehuman').length) {
    $('[data-cms-module-banner]').css('opacity', 1);

    if ($('#fullscreen-scroll-container').length && $('#cmsblock-fullscreen-inside-simplehuman-chapter-05').length) {
      const $blogContainer = $('#cmsblock-sustainability-tile-content-blog');
      $('#cmsblock-fullscreen-inside-simplehuman-chapter-05').append($blogContainer);
    }

    return;
  }

  if (!$('#fullscreen-scroll-container').length) {
    return;
  }

  const $fullscreenScrollContainer = $('#fullscreen-scroll-container');
  const $footerContainer = $('div.shopify-section-group-footer-group');
  $footerContainer.attr('data-fullscreen-scroll-item', '').addClass('fp-auto-height');
  $fullscreenScrollContainer.append($footerContainer);

  checkForScrollTarget();

  setHeaderHeightVariable();
  window.addEventListener('scroll', setHeaderHeightVariable, {
    passive: true,
  });

  new fullpage('.fullscreen-scroll-container', {
    licenseKey: '915033D4-872644F2-BF8F3D10-462BDC5D',
    navigation: false,
    sectionSelector: '[data-fullscreen-scroll-item]',
    fixedElements: '#shopify-section-Header',
    scrollingSpeed: 1000,
    scrollBar: iPadCheck(),
    afterLoad(origin, destination, direction) {
      const currentChapterID = window.fullpage_api.getActiveSection().item.id;
      const $currentChapterIDTarget = $(`#${currentChapterID}`);
      const $originChapterIDTarget = $(`#${origin.item.id}`);

      $currentChapterIDTarget.find('.AnimateOnLoad').addClass('AnimateOnLoad--loaded');
      $originChapterIDTarget.find('.AnimateOnLoad').removeClass('AnimateOnLoad--loaded');
      $originChapterIDTarget.removeClass('down-content-shown').removeClass('up-content-shown');

      switch (direction) {
        case 'down':
          if (
            $currentChapterIDTarget.find('.show-for-up').length ||
            $currentChapterIDTarget.find('.show-for-down').length
          ) {
            $currentChapterIDTarget.addClass('up-content-shown');
          }
          break;
        case 'up':
          if (
            $currentChapterIDTarget.find('.show-for-down').length ||
            $currentChapterIDTarget.find('.show-for-up').length
          ) {
            $currentChapterIDTarget.addClass('down-content-shown');
          }
          break;
        default:
          break;
      }
    },
    onLeave(origin, destination, direction) {
      const $originChapterIDTarget = $(`#${origin.item.id}`);
      window.fullpage_api.setAllowScrolling(false);

      switch (direction) {
        case 'down':
          if (
            $originChapterIDTarget.find('.show-for-up').length ||
            $originChapterIDTarget.find('.show-for-down').length
          ) {
            $originChapterIDTarget.find('.show-for-up').hide();
            $originChapterIDTarget.find('.show-for-down').show();

            if (!$originChapterIDTarget.hasClass('down-content-shown')) {
              $originChapterIDTarget.addClass('down-content-shown').removeClass('up-content-shown');
              return false;
            }
          }
          break;
        case 'up':
          if (
            $originChapterIDTarget.find('.show-for-down').length ||
            $originChapterIDTarget.find('.show-for-up').length
          ) {
            $originChapterIDTarget.find('.show-for-down').hide();
            $originChapterIDTarget.find('.show-for-up').show();

            if (!$originChapterIDTarget.hasClass('up-content-shown')) {
              $originChapterIDTarget.addClass('up-content-shown').removeClass('down-content-shown');
              return false;
            }
          }
          break;
        default:
          break;
      }
    },
    afterRender(origin) {
      const $originChapterIDTarget = $(`#${origin.item.id}`);
      $originChapterIDTarget.find('.AnimateOnLoad').addClass('AnimateOnLoad--loaded');

      checkForScrollTarget();
      enableScrollingLogik($('#fullscreen-scroll-container'));
    },
  });
};

const setHeaderHeightVariable = () => {
  let headerContainerHeight = $('.header-wrapper').outerHeight();

  // if ($('.template-article-ecomm-app-cms').length) {
  //   headerContainerHeight = 0;
  // }

  document.documentElement.style.setProperty('--header-container-height', `${headerContainerHeight}px`);
};

// INIT FUNCTIONS
initFullScreenScroll();
setHeaderHeightVariable();
